// extracted by mini-css-extract-plugin
export default {"feedbackMenu":"FeedbackMenu-feedbackMenu--071ab"};